export default __webpack_public_path__ + "static/media/small-banner.7314d386.jpg";